module.exports = __webpack_public_path__ + "img/copy.bbee2f37.svg";